import { memo } from 'react';
import { PageContainer } from '@/components/templates/PageContainer';
import { PageHeaderSkeleton, NoteItemSkeleton } from '@/components/molecules/skeletons';
import { SKELETON } from '@/lib/constants';

export const NotebookPageSkeleton = memo(() => {
  return (
    <PageContainer>
      <div className="space-y-6">
        <PageHeaderSkeleton />
        <div className="bg-card border border-border rounded-xl shadow-none p-6 space-y-4">
          {Array.from({ length: SKELETON.NOTE_ITEMS }, (_, i) => (
            <NoteItemSkeleton key={i} />
          ))}
        </div>
      </div>
    </PageContainer>
  );
});

NotebookPageSkeleton.displayName = 'NotebookPageSkeleton';
